import Heroimg2 from "../../components/heroimg2/HeroImg2.component";
import Form from "../../components/form/Form.component";
const Contact = () =>{
    return(
        <div>
            <Heroimg2 heading="CONTACT." text="Let's have a chat"/>
            <Form/>
        </div>
    )
}

export default Contact;